// module.exports = {
//   IP_ADRESS: 'http://localhost:8000/',
//   API_ADRESS: 'http://194.102.63.137:3000/'
// }

module.exports = {
  IP_ADRESS: 'https://hera.uvt.ro/',
  API_ADRESS: 'http://194.102.63.137:3000/'
}



// WEBPACK FOOTER //
// ./deploy_conf.js